import { EImageVariant } from '@onesource/schemas';

export enum EMimeType {
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  WEBP = 'image/webp',
  PDF = 'application/pdf',
}

export const FILE_FORMATS: Record<string, EMimeType[]> = {
  IMAGE: [EMimeType.JPEG, EMimeType.PNG, EMimeType.WEBP],
  PDF: [EMimeType.PDF],
  IMAGE_AND_PDF: [EMimeType.JPEG, EMimeType.PNG, EMimeType.WEBP, EMimeType.PDF],
};

export type TVariantOption = { variant: EImageVariant; label: string };

export const VARIANT_OPTIONS: TVariantOption[] = Object.values(EImageVariant).map(variant => ({
  variant,
  label: variant,
}));

export const ALL_VARIANTS_NO_ORIGINAL = Object.values(EImageVariant).filter(v => v !== EImageVariant.original);
